








































































import { userInfo } from "@/api/api.config";
import { Component, Vue } from "vue-property-decorator";
@Component
export default class my extends Vue {
  createTime = "";
  phoneNumber = "";
  userId = "";
  userInfoPhone: any = "";
  showOver = false;
  showBookingManage = false;
  getUserInfo() {
    userInfo().then((res) => {
      console.log(res);
      this.createTime = res.data.createTime;
      this.phoneNumber = res.data.phoneNumber;
      this.userId = res.data.userId;
    });
  }

  mounted() {
    var userType = localStorage.getItem("shopData");
    if (userType == "1") {
      this.showBookingManage = true;
    }
    this.getUserInfo();
    // 1是检测师端   0是用户端
    this.userInfoPhone = localStorage.getItem("shopData");
  }
  exit() {
    this.showOver = true;
    this.$dialog
      .confirm({
        title: "提示",
        message: "是否退出当前账号？",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonColor: "#000000",
        cancelButtonColor: "#999999",
        overlay: true,
        overlayClass: "van-overlay",
      })
      .then(async () => {
        this.showOver = false;
        console.log("点击了确认按钮噢");
        localStorage.removeItem("user-token");
        this.$router.push({
          name: "Login",
        });
      })
      .catch(() => {
        this.showOver = false;
      });
  }
}
